import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { NotificationSettings } from "@/components/core/NotificationSettings";
import { AdminNotifications } from "@/components/core/AdminNotifications";
import { JobRunner } from "@/components/core/JobRunner";
import { AutoAnalysisPanel } from "@/components/adminai/AutoAnalysisPanel";
import { EmailLog } from "@/components/core/EmailLog";

export const NotificationsTab = () => {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [logKey, setLogKey] = useState(0);
  useEffect(() => { api.get("/notifiche").then((r) => setData(r.data)); }, []);
  if (!data) return <div className="text-slate-600" data-testid="notifications-loading">Caricamento...</div>;
  const isAdmin = user.role === "admin";
  return (
    <div className="space-y-6 max-w-5xl" data-testid="notifications-tab">
      <NotificationSettings prefs={data.mie} globali={data.globali} onChange={(mie) => setData((p) => ({ ...p, mie }))} />
      {isAdmin && (
        <>
          <AdminNotifications globali={data.globali} jobs={data.jobs} onChange={(globali) => setData((p) => ({ ...p, globali }))} />
          <JobRunner onRun={() => setLogKey((k) => k + 1)} />
          <AutoAnalysisPanel onRun={() => setLogKey((k) => k + 1)} />
          <EmailLog refreshKey={logKey} />
        </>
      )}
    </div>
  );
};
